import { configureStore } from "@reduxjs/toolkit";
import clientReducer from "./Slices/SelectedClientSlice";
import messageDialogReducer from "./Slices/MessageDialogSlice";
import messageDialogInputReducer from "./Slices/MessageDialogInputSlice";
import messageDialogTemplateReducer from "./Slices/MessageDialogTemplateSlice";
import messageDialogScheduleReducer from "./Slices/MessageDialogScheduleSlice";

export const store = configureStore({
  reducer: {
    selectedClient: clientReducer,
    messageDialog: messageDialogReducer,
    messageDialogInput: messageDialogInputReducer,
    messageDialogTemplate: messageDialogTemplateReducer,
    messageDialogSchedule: messageDialogScheduleReducer,
  },
});

// this is for cypress testing purposes only
export const getStoreForCypress = () =>
  configureStore({
    reducer: {
      selectedClient: clientReducer,
      messageDialog: messageDialogReducer,
      messageDialogInput: messageDialogInputReducer,
      messageDialogTemplate: messageDialogTemplateReducer,
      messageDialogSchedule: messageDialogScheduleReducer,
    },
  });

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
